import React from "react";
import { formatAmount, formatDate, formatStatus } from "../../../../../util/Helpers";

export const BillingDetails = ({ details }) => {
    return (
        <>
            <div className="row">
                <div className="col-lg py-4">
                    <h6>Reference</h6>
                    <span className="text-muted">{details?.ref}</span>
                </div>
                <div className="col-lg py-4">
                    <h6>Product</h6>
                    <span className="text-muted">{details?.product}</span>
                </div>
                <div className="col-lg py-4">
                    <h6>Sub Key</h6>
                    <span className="text-muted">{details?.subKey}</span>
                </div>
            </div>
            <div className="row">
                <div className="col-lg py-4">
                    <h6>User ID</h6>
                    <span className="text-muted">{details?.userId}</span>
                </div>
                <div className="col-lg py-4">
                    <h6>Account ID</h6>
                    <span className="text-muted">{details?.accountId}</span>
                </div>
            </div>
            <div className="row">
                <div className="col-lg py-4">
                    <h6 className=" px">Description</h6>
                    <span className="text-muted">{details?.description}</span>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-4 py-4">
                    <h6>Currency</h6>
                    <span className="text-muted">{details?.currency}</span>
                </div>
                <div className="col-lg py-4">
                    <h6>Price</h6>
                    <span className="text-muted">{formatAmount(details?.currency, details?.price)}</span>
                </div>
                <div className="col-lg py-4">
                    <h6>Charge Amount</h6>
                    <span className="text-muted">{formatAmount(details?.currency, details?.chargeAmount)}</span>
                </div>
                <div className="col-lg py-4">
                    <h6>Status</h6>
                    {formatStatus(details?.status)}
                </div>
            </div>
            <div className="row">
                <div className="col-lg py-4">
                    <h6>Created At</h6>
                    <span className="text-muted">{formatDate(details?.created)}</span>
                </div>
                <div className="col-lg py-4">
                    <h6>Updated At</h6>
                    <span className="text-muted">{formatDate(details?.updated)}</span>
                </div>
            </div>
            <div className="row">
                <div className="col-lg">
                    <h6>Meta</h6>
                    <div className="text-muted bg-light-secondary rounded-lg p-4 overflow-auto" style={{ maxHeight: "300px" }}>
                        <pre className="mb-0">{JSON.stringify(details?.meta, null, 4)}</pre>
                    </div>
                </div>
            </div>
        </>
    )
}